import styled from "styled-components";
import {AdvancedGamesFilterDefaultBox} from "./advanced-games-filter.default.box";


export const AdvancedGamesFilterSIBox = styled(AdvancedGamesFilterDefaultBox)`
    background-color: ${props => props.theme.colors.backgroundDark}; 
`
